//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vuexMixin from "@/lib/vuexMixin";
import strings from "@/strings";
import usersMixin from "@/lib/usersMixin";

export default {
  name: "MenuAdmin",
  mixins: [vuexMixin, usersMixin],
  created() {
    this.$nextTick(async () => {
      await this.buildLinkOptions();
      await this.userValidation();
      this.filteredLinks =
        this.profile === "Administrador" && this.canShowSelectProfile
          ? this.filteredLinksAdministrator
          : this.filteredLinksUser;
      await this.checkUserFirstList();
      this.getSelectedItemByRoute();
      await this.pendingApprovalsCount();
    });
  },
  computed: {
    styleSubMenu() {
      return {
        color: "#9EA1BD",
        opacity: this.opacitySubMenu,
      };
    },
    profile: {
      get() {
        return this.getProfileSelected;
      },
      set(value) {
        this.setProfileSelected(value);
      },
    },
  },

  data() {
    return {
      primaryColor: this.primaryVx,
      mini: false,
      waitDrawer: false,
      height: 80,
      canShowSelectProfile: false,
      showUserTopList: true,
      count: 0,
      userProfile: [
        {
          name: "Administrador",
        },
        {
          name: "Usuário",
        },
      ],
      filteredLinks: [],
      filteredLinksUser: [],
      filteredLinksAdministrator: [],
      linksAdministrator: [
        {
          text: "Gerenciamento",
          subLinks: [
            {
              text: "APIs",
              to: "/admin/apis",
              icon: "mdi-application-brackets-outline",
              permissions: [...strings.rolePermissions.apis],
            },
            {
              text: "Aprovações",
              to: "/admin/approvals",
              icon: "mdi-archive-clock-outline",
              permissions: [...strings.rolePermissions.approval],
            },
            {
              text: "Usuários",
              to: "/admin/users",
              icon: "mdi-account-multiple-outline",
              permissions: [...strings.rolePermissions.users],
            },
            {
              text: "Auditoria",
              to: "/admin/auditoria",
              icon: "mdi mdi-book-open-variant",
              permissions: [...strings.rolePermissions.users],
            },
          ],
        },
        {
          text: "Análise de dados",
          subLinks: [
            {
              text: "Consumo das APIs",
              to: "/admin/consumptionReport",
              icon: "mdi-file-document-outline",
              permissions: [...strings.rolePermissions.apis],
            },
            {
              text: "Painéis",
              to: "/admin/dashboards",
              icon: "mdi-monitor-dashboard",
              permissions: [...strings.rolePermissions.apis],
            },
          ],
        },
        {
          text: "Configurações",
          subLinks: [
            {
              text: "Instituição",
              to: "/admin/institutionSettings",
              icon: "mdi-domain",
              permissions: [...strings.rolePermissions.institutionSettings],
            },
            {
              text: "Tema",
              to: "/admin/themeSettings",
              icon: "mdi-palette-outline",
              permissions: [...strings.rolePermissions.institutionSettings],
            },
            {
              text: "Categorias",
              to: "/admin/category",
              icon: "mdi-tag-multiple-outline",
              permissions: [...strings.rolePermissions.institutionSettings],
            },
            {
              text: "Termos & privacidade",
              to: "/admin/termsPolicy",
              icon: "mdi-sort-variant-lock-open",
              permissions: [...strings.rolePermissions.institutionSettings],
            },
            {
              text: "Perguntas Frequentes",
              to: "/admin/questions",
              icon: "mdi-frequently-asked-questions ",
              permissions: [...strings.rolePermissions.institutionSettings],
            },
            {
              text: "Minha conta",
              to: "/admin/account",
              icon: "mdi-account-outline",
              permissions: [...strings.rolePermissions.institutionSettings],
            },
          ],
        },
      ],
      linksUserTop: [
        // {
        //   text: 'Visão geral',
        //   to: "/admin/generalVision",
        //   icon: 'mdi-chart-box-outline',
        //   permissions : [...strings.rolePermissions.apiConsumed],
        // },
        {
          text: "APIs consumidas",
          to: "/admin/apiConsumed",
          icon: "mdi-code-tags",
          permissions: [...strings.rolePermissions.apiConsumed],
        },
        {
          text: "APIs salvas",
          to: "/admin/savedApis",
          icon: "mdi-bookmark-outline",
          permissions: [...strings.rolePermissions.savedApis],
        },
      ],
      linksUser: [
        {
          text: "Análise de dados",
          subLinks: [
            {
              text: "Relatório de consumo",
              to: "/admin/consumerConsumptionReport",
              icon: "mdi-cog-outline",
              permissions: [
                ...strings.rolePermissions.consumerConsumptionReport,
              ],
            },
          ],
        },
        {
          text: "Configurações",
          subLinks: [
            // {
            //   text : "Cartão de crédito",
            //   to    : "admin/creditCard",
            //   icon  : "mdi-credit-card-outline",
            //   permissions :  [...strings.rolePermissions.institutionSettings],
            // },
            // {
            //   text : "Nome da empresa",
            //   to    : "admin/companyName",
            //   icon  : "mdi-domain",
            //   permissions : [
            //     ...strings.rolePermissions.institutionSettings],
            // },
            {
              text: "Minha conta",
              to: "/admin/account",
              icon: "mdi-account-outline",
              permissions: [...strings.rolePermissions.account],
            },
          ],
        },
      ],
    };
  },
  methods: {
    goTo(path) {
      this.$router.push(path);
    },
    changeDrawer() {
      this.waitDrawer = true;
      setTimeout(() => {
        this.waitDrawer = false;
      }, 100);
      this.mini = !this.mini;
    },
    buildLinkOptions() {
      this.linksAdministrator.forEach((link) => {
        if (link.subLinks) {
          const list = this.buildSubLinkOptions(link.subLinks);
          if (list.length > 0) {
            link.subLinks = list;
            this.filteredLinksAdministrator.push(link);
          }
        } else {
          this.filteredLinksAdministrator.push(link);
        }
      });
      this.linksUser.forEach((link) => {
        if (link.subLinks) {
          const list = this.buildSubLinkOptions(link.subLinks);
          if (list.length > 0) {
            link.subLinks = list;
            this.filteredLinksUser.push(link);
          }
        } else {
          this.filteredLinksUser.push(link);
        }
      });
    },
    buildSubLinkOptions(sublinks) {
      let filteredSubLinks = [];
      sublinks.forEach((sublink) => {
        if (this.canShowSubLinkMenu(sublink)) {
          filteredSubLinks.push(sublink);
        }
      });
      return filteredSubLinks;
    },
    async changeSelectedProfile(event) {
      if (event === "Administrador") {
        this.$router.push("/admin/apis");
      } else if (event === "Usuário") {
        this.$router.push("/admin/apiConsumed");
      }
      this.filteredLinks =
        event === "Administrador" && this.canShowSelectProfile
          ? this.filteredLinksAdministrator
          : this.filteredLinksUser;
      this.checkUserFirstList();
    },

    async checkUserFirstList() {
      this.showUserTopList =
        this.profile == "Usuário" || !this.canShowSelectProfile;
    },

    async userValidation() {
      this.canShowSelectProfile = await this.getRolesUser.some(
        (roleUser) => roleUser === "GET/user"
      );
    },

    canShowSubLinkMenu(subLink) {
      let result = true;
      if (subLink.permissions && subLink.permissions.length > 0) {
        result = subLink.permissions.every((route) => this.haveRole(route));
      } else {
        result = true;
      }
      return result;
    },
    handleSelectItem(item) {
      this.selectedItemMenu = item.to;
      this.goTo(item.to);
    },
    handleSelecGroup(item) {
      const menu = `${this.profile}/${item.text}`;
      if (this.isGroupActive(item)) {
        this.setRemoveMenuGroupsActive(menu);
      } else {
        this.setMenuGroupsActive(menu);
      }
      this.$nextTick(() => (this.count += 1));
    },
    isGroupActive(item) {
      return this.getMenuGroupsActive.includes(`${this.profile}/${item.text}`);
    },
    async pendingApprovalsCount() {
      try {
        const response = await this.requestEds("GET", "activated-apis/count/");
        if (response && response.data && response.data.pendingApprovals) {
          this.setCountApproval(response.data.pendingApprovals);
        } else if (
          response &&
          response.data &&
          response.data.pendingApprovals === 0
        ) {
          this.setCountApproval("");
        }
      } catch (error) {
        if (error) {
          this.setCountApproval(0);
        }
      }
    },
  },
};
